import { render, staticRenderFns } from "./adminRegister.vue?vue&type=template&id=2435507a&"
import script from "./adminRegister.vue?vue&type=script&lang=js&"
export * from "./adminRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports